import useResource from "../../../hooks/UseResource";
import * as DoctorService from "../../../services/DoctorService";

export default function useDoctor(id) {
    return useResource(id, DoctorService.findDoctorById);
}
